import { render, staticRenderFns } from "./GiftsBoxCategoryProducts.vue?vue&type=template&id=087d3770&scoped=true&"
import script from "./GiftsBoxCategoryProducts.vue?vue&type=script&lang=js&"
export * from "./GiftsBoxCategoryProducts.vue?vue&type=script&lang=js&"
import style0 from "./GiftsBoxCategoryProducts.vue?vue&type=style&index=0&id=087d3770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087d3770",
  null
  
)

export default component.exports